/* True Family — pack card selected-state toggle (fallback for :has()). */
(function () {
  function syncCards(scope) {
    var cards = (scope || document).querySelectorAll('.tf-pack-card');
    cards.forEach(function (card) {
      var input = card.querySelector('.tf-pack-card__input');
      if (input && input.checked) {
        card.classList.add('is-selected');
      } else {
        card.classList.remove('is-selected');
      }
    });
  }

  function handleChange(e) {
    var target = e.target;
    if (!target || !target.classList || !target.classList.contains('tf-pack-card__input')) return;
    var group = target.closest('.tf-pack-cards');
    if (group) syncCards(group);
  }

  // Update card content (price/MRP/save/desc/thumb) to match other selected options (e.g. flavor).
  function updateCardContent(variant) {
    if (!variant || !variant.options) return;
    document.querySelectorAll('.tf-pack-cards').forEach(function (group) {
      var dataEl = group.parentNode.querySelector('.tf-pack-cards-data');
      if (!dataEl) return;
      var data;
      try {
        data = dataEl._tfData || (dataEl._tfData = JSON.parse(dataEl.textContent));
      } catch (err) {
        return;
      }
      if (!data[variant.id]) return; // different product's picker
      var idx = Number(group.dataset.optionPosition) - 1;
      var ids = Object.keys(data);

      group.querySelectorAll('.tf-pack-card').forEach(function (card) {
        var value = card.dataset.value;
        var match = null;
        var fallback = null;
        ids.forEach(function (id) {
          var opts = data[id].options;
          if (match || opts[idx] !== value) return;
          if (!fallback) fallback = data[id];
          var same = opts.every(function (o, i) {
            return i === idx || o === variant.options[i];
          });
          if (same) match = data[id];
        });
        var entry = match || fallback;
        var content = card.querySelector('.tf-pack-card__content');
        if (entry && content && content.innerHTML !== entry.html) {
          content.innerHTML = entry.html;
        }
      });
    });
  }

  function sizedUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  // Flavor (image) swatches: show image of variant matching swatch value + other selected options (e.g. pack).
  function updateImageSwatches(variant) {
    if (!variant || !variant.options) return;
    document.querySelectorAll('variant-picker').forEach(function (picker) {
      var dataEl = picker.querySelector('#productVariants');
      if (!dataEl) return;
      var variants;
      try {
        variants = picker._tfVariants || (picker._tfVariants = JSON.parse(dataEl.textContent));
      } catch (err) {
        return;
      }
      if (!variants.some(function (v) { return v.id === variant.id; })) return; // different product's picker

      picker.querySelectorAll('.m-product-option--node[data-option-type="image"]').forEach(function (node) {
        if (node.hasAttribute('data-tf-product-swatch')) return; // fixed per-flavor swatch from product metafield
        var idx = Number(node.dataset.optionPosition) - 1;
        var value = node.dataset.value;
        var match = null;
        var fallback = null;
        variants.forEach(function (v) {
          if (match || v.options[idx] !== value) return;
          if (!fallback) fallback = v;
          var same = v.options.every(function (o, i) {
            return i === idx || o === variant.options[i];
          });
          if (same) match = v;
        });
        var target = match || fallback;
        var label = node.querySelector('label');
        if (!target || !label || !target.featured_image || !target.featured_image.src) return;
        label.style.backgroundImage = 'url(' + sizedUrl(target.featured_image.src, 160) + ')';
        label.classList.add('has-bg-img');
      });
    });
  }

  // Re-apply product-metafield swatches (theme JS may overwrite them on init).
  function applyProductSwatches() {
    document.querySelectorAll('[data-tf-product-swatch]').forEach(function (node) {
      var url = node.getAttribute('data-tf-product-swatch');
      var label = node.querySelector('label');
      if (!url || !label) return;
      label.style.backgroundImage = 'url(' + url + ')';
      label.classList.add('has-bg-img');
      label.classList.remove('option-loading');
    });
  }

  // Current variant from checked inputs (for initial load, after theme sets default swatches).
  function initImageSwatches() {
    applyProductSwatches();
    document.querySelectorAll('variant-picker').forEach(function (picker) {
      var dataEl = picker.querySelector('#productVariants');
      if (!dataEl) return;
      var variants;
      try {
        variants = picker._tfVariants || (picker._tfVariants = JSON.parse(dataEl.textContent));
      } catch (err) {
        return;
      }
      var selected = {};
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        var node = input.closest('[data-option-position]');
        if (node) selected[Number(node.dataset.optionPosition) - 1] = input.value;
      });
      picker.querySelectorAll('select[name^="options["]').forEach(function (sel) {
        var opt = sel.selectedOptions[0];
        if (opt && opt.dataset.optionPosition) selected[Number(opt.dataset.optionPosition) - 1] = sel.value;
      });
      var current = variants.find(function (v) {
        return v.options.every(function (o, i) {
          return selected[i] === undefined || selected[i] === o;
        });
      });
      if (current) updateImageSwatches(current);
    });
  }

  document.addEventListener('variant:changed', function (e) {
    var variant = e.detail && e.detail.variant;
    updateCardContent(variant);
    updateImageSwatches(variant);
  });

  window.addEventListener('load', function () {
    setTimeout(initImageSwatches, 0);
  });

  document.addEventListener('change', handleChange, true);
  document.addEventListener('DOMContentLoaded', function () {
    syncCards(document);
  });

  // Also observe DOM updates (theme editor / variant-picker re-renders).
  var mo = new MutationObserver(function () {
    syncCards(document);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
